<template>
    <el-row class="main">
        <!-- 头部nav -->
        <!-- <Navi></Navi> -->
        <!-- 侧边nav -->
        <!-- <el-button size="mini">缩回</el-button> -->
        <i class="el-icon-s-fold button" @click="isCollapse = !isCollapse; toggle()" v-if="!isCollapse && $wxOpenId"></i>
        <i class="el-icon-s-unfold button" @click="isCollapse = !isCollapse; toggle()" v-if="isCollapse && $wxOpenId"></i>
        <aside class="sidebar" :class="isCollapse ? 'collapse' : ''" v-if='$wxOpenId'>
            <!-- <el-menu :default-active="$route.path" class="el-menu-vertical-demo" router :collapse="isCollapse">
                    <template v-for="(item,index) in secendNode">
                        <el-submenu :index="index+''" v-if="!item.hidden && !item.leaf" class="scrollContent">
                            <template slot="title"><img :src='item.icon' class="icon"/><span slot="title">{{item.name}}</span></template>
                            <el-menu-item 
                                v-for="child in item.children" 
                                :index="child.path"
                                :key="child.path"
                                v-if="!child.hidden"
                            >{{child.name}}
                            </el-menu-item>
                        </el-submenu>
                    </template>
                </el-menu> -->
            <ul>
                <li v-for="(item, index) in secendNode" v-if="!item.hidden && !item.leaf" class="li1">
                    <div class="li1title"><span><img :src='item.icon' /></span>
                        <div class="li1titletext">{{ item.name }}</div>
                    </div>
                    <ul class="ul2">
                        <li v-for="child in item.children" class="li2" :class="{ 'active': $route.path == child.path }"
                            v-if="!child.hidden" @click="$router.push(child.path)">
                            {{ child.name }}
                        </li>
                    </ul>
                    <div class="bootmline"></div>
                </li>

            </ul>
        </aside>
        <!-- 面包屑 -->
        <section class="content-container" :class='$wxOpenId ? "" : "wx-content-container"'>
            <el-col :span="24" class="breadcrumb-container">
                <el-breadcrumb separator="/" class="breadcrumb-inner">
                    <el-breadcrumb-item v-for="item in $route.matched" :key="item.path">
                        {{ item.name }}
                    </el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
            <el-col :span="24" class="content-wrapper" ref="contentWrapper">
                <router-view></router-view>
            </el-col>
        </section>
    </el-row>
</template>

<script>
import * as Events from '../helper/Events';
import Navi from './Navi';
import MenuUtils from '@/utils/MenuUtils'
import * as Urls from '../helper/Urls';
import * as VueHelper from '../helper/VueHelper';


export default {
    components: {
        Navi
    },
    data() {
        return {
            nodes: this.$router.options.routes,
            isCollapse: false,
        }
    },
    created() {

        //这里没有直接使用this.$router.options.routes，是因为addRoute的路由规则，在这里this.$router.options.routes获取不到
        //有兴趣的可以看一下源码，是为什么获取不到，但是却又有规则了
        //另外在开发的时候，可能由于是热部署，也会不断重复的给nodes添加元素，造成导航条有重复的，简单解决，可以设置一个开关
        let inst = this;
        let data = JSON.parse(window.sessionStorage.getItem('userPre'))

        this.nodes = [];
        this.nodes.push(...data)
        console.log(this.nodes)
        // console.log(JSON.stringify(this.nodes))

    },
    methods: {
        toggle() {
            this.$nextTick(function () {
                var myEvent = new Event('resize');
                window.dispatchEvent(myEvent);
            });
        }
    },
    mounted() {
        // console.log(343,this.nodes)
        // console.log(344,this.secendNode)
    },

    computed: {
        secendNode() {
            let inst = this;
            let path = this.$route.path;
            for (let i = 0; i < this.nodes.length; i++) {
                let item = this.nodes[i];
                console.log(item)
                if (!item.children) { continue; }
                for (let j = 0; j < item.children.length; j++) {
                    let children = item.children[j];
                    // console.log(children.children);
                    if (!children.children) { continue; }
                    for (let k = 0; k < children.children.length; k++) {
                        let child = children.children[k];
                        // console.log("------"+child.path);
                        if (child.path == path) {
                            inst.isActiveName = item.name;
                            return item.children;
                            break;
                        }
                    }
                }
            }

            return []
        },
    },
}

</script>

<style scoped lang="scss">
@import "../assets/css/common.css";

.main {
    // display: flex;
    // position: absolute;
    // top: 60px;
    // bottom: 0px;
    // overflow: hidden;
    padding-bottom: 20px;
    background-color: #fff;

    .button {
        position: fixed;
        top: 21px;
        z-index: 1001;
        left: 186px;
        font-size: 22px;
        cursor: pointer;
    }

    aside {
        // width: 170px;
        // float: left;
        // padding-left: 30px;
        // margin-bottom: -9999px;
        // padding-bottom: 9999px;
        // background-color: #F5F5F7;
        width: 170px;
        padding-left: 30px;
        background-color: #F5F5F7;
        height: calc(100vh - 60px);
        position: fixed;
        top: 60px;
        overflow: hidden;

        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }

        ::-webkit-scrollbar-thumb {
            background-color: #c2c2c2;
            background-clip: padding-box;
            min-height: 28px;
        }

        ::-webkit-scrollbar-track-piece {
            background-color: #F5F5F7;
        }

        >ul {
            overflow-y: scroll;
            overflow-x: hidden;
            height: 100%;
        }

        &.collapse {
            width: 43px;
            overflow: hidden;

            .li1titletext,
            .ul2,
            .bootmline {
                display: none;
            }
        }

        ul,
        li {
            margin: 0;
            padding: 0;
        }

        li {
            list-style: none;
            margin: 30px 0;
        }

        .li1 {
            color: #999;

            &:last-child .bootmline {
                border-bottom: 0 none;
            }

            .li1title {
                display: flex;
                align-items: center;

                span {
                    display: block;
                    width: 16px;
                    height: 16px;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    img {
                        max-width: 100%;
                        max-height: 100%;
                    }
                }

                .li1titletext {
                    padding-left: 8px
                }
            }

            .bootmline {
                margin-left: 24px;
                // width: 80%;
                width: 146px;
                border-bottom: 1px #D2D2D7 solid;
            }
        }

        .li2 {
            color: #000;
            cursor: pointer;
            padding-left: 24px;

            &.active {
                color: #0077CC;
            }
        }

        .icon {
            width: 16px;
            height: 16px;
            display: inline-block;
            margin-right: 8px;
        }
    }


}

.content-container {
    // margin-bottom: -9999px;
    // padding-bottom: 9999px !important;
    margin-left: 200px;
    padding: 20px;

    .breadcrumb-container {
        .breadcrumb-inner {
            float: left;
            font-size: 11px;
        }
    }
}

.wx-content-container {
    margin-left: auto;
}

aside.collapse+.content-container {
    margin-left: 73px;
}
</style>
<style>
.el-menu {
    background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// Navigation.vue?20bb7115